import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ConnectionState } from '../utils/connectionState';
import { AppDispatch } from './store';

interface NotificationsState {
  connectionState: ConnectionState;
  connectionUpdatedAt: string;
}

const initialState = {
  connectionState: ConnectionState.NotConnected,
  connectionUpdatedAt: '',
} satisfies NotificationsState as NotificationsState;

const slice = createSlice({
  name: 'notifications',
  initialState: initialState,
  reducers: {
    updateConnectionState: (state, action: PayloadAction<ConnectionState>) => {
      return {
        ...state,
        connectionState: action.payload,
        connectionUpdatedAt: new Date().toISOString(),
      };
    },
  },
});

export default slice.reducer;

// Actions
const { updateConnectionState } = slice.actions;

export const updateConnection =
  (connectionState: ConnectionState) => async (dispatch: AppDispatch) => {
    dispatch(updateConnectionState(connectionState));
  };
